import { create } from 'zustand';
import { Photo } from '../types';

export type UploadTaskStatus = 'queued' | 'uploading' | 'done' | 'failed';

export interface UploadTask {
  id: string;
  filename: string;
  size: number;
  eventId: string;
  status: UploadTaskStatus;
  error?: string;
  photo?: Photo;
  /** Small data: URL thumbnail of the file, generated lazily for display. */
  previewUrl?: string;
}

interface UploadStore {
  tasks: UploadTask[];
  isUploading: boolean;
  selectionActive: boolean;
  addTasks: (tasks: UploadTask[]) => void;
  updateTask: (id: string, patch: Partial<UploadTask>) => void;
  setUploading: (v: boolean) => void;
  setSelectionActive: (v: boolean) => void;
  clearDoneFor: (eventId: string) => void;
  clearQueuedFor: (eventId: string) => void;
  clearAll: () => void;
}

export const useUploadStore = create<UploadStore>((set) => ({
  tasks: [],
  isUploading: false,
  selectionActive: false,
  addTasks: (newTasks) => set((s) => ({ tasks: [...s.tasks, ...newTasks] })),
  updateTask: (id, patch) =>
    set((s) => ({ tasks: s.tasks.map((t) => (t.id === id ? { ...t, ...patch } : t)) })),
  setUploading: (isUploading) => set({ isUploading }),
  setSelectionActive: (selectionActive) => set({ selectionActive }),
  clearDoneFor: (eventId) =>
    set((s) => ({
      tasks: s.tasks.filter((t) => t.eventId !== eventId || (t.status !== 'done' && t.status !== 'failed')),
    })),
  clearQueuedFor: (eventId) =>
    set((s) => ({
      tasks: s.tasks.filter((t) => t.eventId !== eventId || t.status !== 'queued'),
    })),
  clearAll: () => set({ tasks: [], isUploading: false }),
}));
